import restApi from "@/api/rest-api-object";

const RESOURCE_NAME = '/locator';

export default axios => ({
    ...restApi(axios, `${RESOURCE_NAME}/tokens`),
    getToken(data, params){
        return axios.post(`${RESOURCE_NAME}/token`, data, {params});
    },
    getUnits(data, params){
        return axios.post(`${RESOURCE_NAME}/units`, data, {params});
    },
    getAppUser(data, params){
        return axios.post(`${RESOURCE_NAME}/app-user`, data, {params});
    },
    getUnitsLmsgs(data, params){
        return axios.post(`${RESOURCE_NAME}/units-lmsgs`, data, {params});
    },
    getUnitWeather(unitId, data, params){
        return axios.post(`${RESOURCE_NAME}/unit/${unitId}/weather`, data, {params});
    },
    checkToken(data, params){
        return axios.post(`${RESOURCE_NAME}/check`, data, {params});
    },
});